import { FocusKeys, focusZone } from '@primer/behaviors';
import { Context, Controller } from '@hotwired/stimulus';
import { toggleAttribute } from 'src/utils/dom-toggle';

export default class ShareController extends Controller {
  static values = {
    url: String,
    text: String,
    title: String,
  };

  declare hasUrlValue: boolean;
  declare hasTextValue: boolean;
  declare hasTitleValue: boolean;

  declare urlValue: string;
  declare textValue: string;
  declare titleValue: string;

  private useTextShareData: boolean = false;

  public constructor(context: Context) {
    super(context);

    this.onShare = this.onShare.bind(this);
  }

  public connect(): void {
    if (!('share' in navigator)) {
      return;
    }

    if ('canShare' in navigator) {
      if (navigator.canShare(this.shareData)) {
        this.useTextShareData = false;
      } else if (
        navigator.canShare(this.textShareData) ||
        navigator.canShare()
      ) {
        this.useTextShareData = true;
      } else {
        return;
      }
    }

    toggleAttribute('disabled', this.element, false);

    this.element.addEventListener('click', this.onShare);
  }

  public disconnect(): void {
    this.element.removeEventListener('click', this.onShare);

    toggleAttribute('disabled', this.element, true);
  }

  private get shareData(): ShareData {
    const data: ShareData = {};

    if (this.hasTextValue) {
      data.text = this.textValue;
    }

    if (this.hasTitleValue) {
      data.title = this.titleValue;
    }

    if (this.hasUrlValue) {
      data.url = this.urlValue;
    }

    return data;
  }

  private get textShareData(): ShareData {
    const data: ShareData = {};

    if (this.hasTitleValue) {
      data.text = this.titleValue;
    }

    if (this.hasTextValue) {
      data.text = this.textValue;
    }

    if (this.hasUrlValue) {
      data.text = this.urlValue;
    }

    return data;
  }

  private onShare() {
    const data = this.useTextShareData ? this.textShareData : this.shareData;

    return navigator
      .share(data)
      .catch(() => {
        /* ignore errors */
      })
      .then(() => console.debug('[share] completed share', data));
  }
}
